// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__21rRu","validationTips":"StatementDescriptor_validationTips__1R2uy"};